import { render } from "./InstructorProfile.vue?vue&type=template&id=20d4cbb8"
import script from "./InstructorProfile.vue?vue&type=script&lang=js"
export * from "./InstructorProfile.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__